export enum DecisionEnum {
  AcknowledgeQueueRequest = 1,
  ReopenRequest = 2,
  CloseRequest = 3,
  AssignRnDManager = 4
}
